import * as API from 'core/api';

import { Bus, ValidationErrors } from 'core/infrastructure';
const process = Bus.buildProcessFn('/bus/');

export async function getRegularSuppliers(): Promise<API.SupplierInListDTO[]> {
	const request = new API.GetAllSuppliersRequest();
	return await process(request, (response: API.GetAllSuppliersResponse) => response.All);
}

export async function createLoss(ticketId: number, reason: string): Promise<API.SupplierInListDTO[]> {
	const request = new API.CreateLossRequest({ ticketId, reason });
	return process(request);
}

export async function searchLotByNumber(lotNumber: string, productId: number, saleCenterId: number): Promise<API.LotInListDTO[]> {
	const request = new API.SearchLotsWithStockInCurrentPosRequest({ productId, numberPattern: lotNumber, exactMatch: false, currentSaleCenterId: saleCenterId });
	return process(request, (response: API.SearchLotsWithStockInCurrentPosResponse) => response.Lots);
}

export async function searchLotByBarcode(lotNumber: string, productId: number): Promise<API.LotInListDTO[]> {
	const request = new API.SearchLotsRequest({ productId, numberPattern: lotNumber, exactMatch: true });
	return process(request, (response: API.SearchLotsWithStockInCurrentPosResponse) => response.Lots);
}

export async function createLot(productId: number): Promise<API.LotForEditionDTO> {
	const data = await process(new API.CreateLotRequest(), (response: API.CreateLotResponse) => response.Data);
	const product = await process(new API.GetProductDetailsForLotsByIdRequest({ id: productId }), (response: API.GetProductDetailsForLotsByIdResponse) => response.Product);
	data.Product = product;
	return data;
}

export function editLot(lotId: number): Promise<API.LotForEditionDTO> {
	const request = new API.EditLotRequest({ id: lotId });
	return process(request, (response: API.EditLotResponse) => response.Data);
}

export function saveLot(data: API.LotForEditionDTO): Promise<void> {
	const request = new API.SaveLotRequest({ data });
	return process(request);
}

export function removeLot(lotId: number): Promise<void> {
	const request = new API.DeleteLotRequest({ id: lotId });
	return process(request);
}

export function validateLot(data: API.LotForEditionDTO): Promise<ValidationErrors> {
	const request = new API.ValidateLotRequest({ data });
	return process(request, (response: API.ValidateLotResponse) => {
		return response.Notification.Messages.reduce((errors: ValidationErrors, message) => {
			ValidationErrors.add(errors, message.PropertyName, message.MessageText);
			return errors;
		}, {});
	});
}